import { data } from "react-router-dom";
import { create } from "zustand";

const usePatientStore = create((set) => ({
  currentSession:null,
  transcript: null,
  final_summary: null,
  audio_url: null,
  summary1: null,
  summary2: null,
  summary3: null,
  consultationId: null,
  loading: false,
  unread_count: 0,
  sopnotes: null,
  surgicalNote:null,
  doctor_letter:null,
  surgicalRecording:null,

  setCurrentSession:(session)=> set({currentSession:session}),
  setTranscriptData: (data) => set({ transcript: data }),
  setFinalSummary: (data) => set({ final_summary: data }),
  setAudioUrlData: (url) => set({ audio_url: url }),
  setConsultationId: (id) => set({ consultationId: id }),
  setLoading: (data) => set({ loading: data }),
  increaseUnread: () =>
    set((state) => ({ unread_count: state.unread_count + 1 })),
  setSummary1: (data) => set({ summary1: data }),
  setSummary2: (data) => set({ summary2: data }),
  setSummary3: (data) => set({ summary3: data }),
  setSopnotes: (data) => set({sopnotes:data}),
  setSurgicalNote: (data)=> set({surgicalNote:data}),
  setDoctorLetter: (data)=> set({doctor_letter:data}),
  setSurgicalRecording:(data)=>set({surgicalRecording:data}),
  decreaseUnread: () =>
    set((state) => ({
      unread_count: state.unread_count > 0 ? state.unread_count - 1 : 0,
    })),

  getConsultationDetail: async (consultationId) => {
    const token = sessionStorage.getItem("token");
    set({ loading: true });
    const url = `${process.env.REACT_APP_SERVER_URL}/consultations/files/${consultationId}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`
        },
      });

      if (!response.ok) {
        set({ loading: false });
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.log("consultation is fetched using id: ",consultationId)
      console.log(data);
      set({ loading: false });
      set({
        transcript: data.transcript,
        final_summary: data.finalSummary,
        audio_url: data.recording_file,
        summary1: data.recordingSummary1,
        summary2: data.recordingSummary2,
        summary3: data.recordingSummary3,
        sopnotes: data.sopnotes,
        surgicalNote:data.surgicalNote,
        doctor_letter:data.doctor_letter,
        surgicalRecording:data.surgical_recording_filename
      });
    } catch (error) {
      set({ loading: false });
      console.error("Error fetching consultation details:", error);
    }
  },
}));

export default usePatientStore;
